/* eslint-disable */

import parsePhoneNumber from 'libphonenumber-js';
import ProfileRegistrationValidationConfig from '@com.amway.commerce/profile-registrationvalidations-v1-prod/data.json';
import { OperationType } from '@commerce-identity-webcomponents/sdk';

export interface EmailValidationData {
  pk?: string;
  fieldName?: string;
  visible?: boolean;
  editable?: boolean;
  validations?: {
    BUSINESS_OWNER: EmailValidationRule;
    CUSTOMER: EmailValidationRule;
  };
}

interface EmailValidationRule {
  required?: boolean;
  regex?: string;
  visible?: boolean;
}

export const PasswordRegex =
  /^(?=.*?\d)(?=.*?[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])(?=.*?[\u0E00-\u0E7F\u0370-\u03FF\u3040-\u309F\u30A0-\u30FFa-zA-Z])(?!.*?[^\u0E00-\u0E7F\u0370-\u03FF\u3040-\u309F\u30A0-\u30FFa-zA-Z0-9 !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]).{8,100}$/;

export const isEmail = (email: string, operationType?: string) => {
  const emailJSONObject = ProfileRegistrationValidationConfig.find(
    ({ pk, fieldName }) => pk === 'email' && fieldName === 'email',
  ) as EmailValidationData;

  if (!emailJSONObject) return false;

  const domainRemove = 'amway';
  const originalPattern = emailJSONObject?.validations?.BUSINESS_OWNER?.regex;
  if (!originalPattern) return false;
  let blacklistedDomains: string[] = [];
  let emailPattern = originalPattern;
  const blockedDomainsMatch = originalPattern?.match(/@\(\?!\(\?:([^)]+)\)/);

  // Check and update pattern if blacklist domains were found
  if (blockedDomainsMatch?.[1] && operationType) {
    const domainGroup = blockedDomainsMatch[1];
    if (OperationType.UPSERT === operationType) {
      //Remove amway domain from blacklisted domains
      blacklistedDomains = domainGroup
        .split('|')
        .map((d) => d.toLowerCase())
        .filter((d) => d !== domainRemove);
    } else if (OperationType.CHECK === operationType) {
      // Remove all blacklisted domains
      blacklistedDomains = [];
    }
    const newDomainGroup = blacklistedDomains.join('|');
    emailPattern = emailPattern.replace(domainGroup, newDomainGroup);
  }

  const updatedBlacklistedDomains =
    emailPattern
      ?.match(/@\(\?!\(\?:([^)]+)\)/)?.[1]
      .split('|')
      .map((d) => d.toLowerCase()) ?? [];

  // validate domain has consecutive multiple dots
  const domain = email.split('@')[1]?.toLowerCase() || '';
  if (domain.includes('..')) return false;

  const isBlacklisted = updatedBlacklistedDomains.some((bd) => domain.startsWith(bd));

  const updatedEmailRegex = new RegExp(emailPattern, 'i');
  if (isBlacklisted && email.search(updatedEmailRegex) === -1) return { invalidDomain: true };
  else return email.search(updatedEmailRegex) !== -1;
};

export const isNumber = (n: string) => {
  const numStr = /^\d*$/;
  return numStr.test(`${n}`);
};

export const formatPhoneNumber = (m: string) => parsePhoneNumber(m)?.formatInternational();

export const OTPAPI_BASE_URL = 'https://global-dev.amcom-corp-preprod.amway.net';

export const parseCountryCode = (phoneNumberStr: string) => {
  const obj = parsePhoneNumber(phoneNumberStr);
  return { countryCode: obj?.countryCallingCode, mobileNumber: obj?.number };
};
